import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { ArrowDown } from '../icons/arrow-down';
import styles from './dropdown-button.scss';
import MoreButton from '../more-button';
import withTranslate from '../../../common/components/with-translate/with-translate';

const OpenButton = ({ text, isOpen }) => (
  <div className={classNames(styles.openButton, 'button-primary-text-color')}>
    <span>{text}</span>&nbsp;
    <span
      className={classNames('button-primary-icon-fill', styles.arrow, {
        [styles.arrowUp]: isOpen,
      })}
    >
      <ArrowDown />
    </span>
  </div>
);

export class DropdownButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.containerRef = React.createRef();
  }

  showComponent = () => {
    const { onDropdownShow } = this.props;
    this.setState({ isOpen: true });
    onDropdownShow && onDropdownShow();
  };

  hideComponent = () => this.setState({ isOpen: false });

  getParentRef = () => this.containerRef;

  render = () => {
    const { className, children, isSmall = true, dataHook, label, t } = this.props;

    return (
      <div data-hook={dataHook} ref={this.containerRef}>
        <MoreButton
          ariaLabel={t(label)}
          icon={<OpenButton isOpen={this.state.isOpen} text={t(label)} />}
          className={classNames(styles.moreButtonContainer, {
            [styles.small]: isSmall,
          })}
          buttonClassName={classNames(styles.moreButton, 'button-background-color')}
          actionsContainerClassName={classNames(styles.dropdown, className)}
          onHide={this.hideComponent}
          onShow={this.showComponent}
          parentRef={this.getParentRef}
          size={MoreButton.SIZE_EXTENDED}
        >
          {children}
        </MoreButton>
      </div>
    );
  };
}

DropdownButton.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  t: PropTypes.func.isRequired,
  isSmall: PropTypes.bool,
  onDropdownShow: PropTypes.func,
};

DropdownButton.defaultProps = {
  dataHook: 'dropdown-select',
};

export default flowRight(withTranslate)(DropdownButton);
